// extracted by mini-css-extract-plugin
module.exports = {"Team":"Team_Team__JEIwX","Header":"Team_Header__lk0s0","Desc":"Team_Desc__jJkCc"};